module.exports = __webpack_public_path__ + "static/g5-d9b991f1404b0ba4e073aa1c021938b1.jpg";